export type CreditCardStatus =
  | 'CREATED'
  | 'ACTIVE'
  | 'DEACTIVATED'
  | 'INACTIVE'
  | 'LOCKED'
  | 'LOST'
  | 'STOLEN';

export interface CreditCard {
  __typename?: 'CreditCard';
  alias?: string;
  creditCardId: string;
  cardDesign: string;
  cardProductId?: string;
  cardHolderName: string;
  companyUserId: string;
  createdAt: number;
  deactivateAt: string | null;
  expiryDate: number;
  isDefinitivelyBlocked: boolean;
  isPhysical: boolean;
  isPremium: boolean;
  limitAtmMonth: number;
  limitPaymentAll: number;
  limitPaymentWeek: number;
  maskedPan: string;
  maxLimitAtmMonth: number;
  maxLimitPaymentWeek: number;
  optionAtm: boolean;
  optionNfc: boolean;
  optionOnline: boolean;
  pinTryExceeds: boolean;
  status: CreditCardStatus;
  totalAtmMonth: number;
  totalPaymentAll: number;
  totalPaymentWeek: number;
  updatedAt: number;
}

export enum PaymentCardType {
  PHYSICAL = 'physical',
  VIRTUAL = 'virtual',
  TEMPORARY_VIRTUAL = 'temporaryVirtual',
}
